var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 104,
    viewBox: "0 0 160 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.997 0.000754838C116.464 0.000754838 115.956 0.21203 115.581 0.591146L79.7545 36.6609L58.789 57.8553C58.0057 58.6459 56.7329 58.6459 55.9489 57.8553L24.193 25.6488C23.4237 24.8692 22.1759 24.8553 21.389 25.6128L0.609802 45.6735C-0.188181 46.4464 -0.205866 47.7193 0.573714 48.5099L34.0073 82.4117L55.96 103.446C56.7433 104.196 57.9844 104.182 58.75 103.417L79.7552 82.4117L102.631 59.5359L125.507 36.6601L158.758 3.4091C160.013 2.15397 159.122 0.0044212 157.349 0.0044212H117.001L116.998 0L116.997 0.000754838Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSymbol);
export default __webpack_public_path__ + "static/media/checkSymbol.18a81b462804d7aaf846145069fa8209.svg";
export { ForwardRef as ReactComponent };